/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconWarning = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 140 140"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 140px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path
          strokeLinejoin="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M70 109.375a2.188 2.188 0 1 0 2.188 2.188A2.188 2.188 0 0 0 70 109.374h0"
        />
        <path
          strokeMiterlimit={10}
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M70 91.875v-43.75"
        />
        <path
          strokeLinejoin="round"
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M79.456 10.267a10.535 10.535 0 0 0-18.912 0L5.285 122.838a8.872 8.872 0 0 0 7.968 12.787h113.494a8.872 8.872 0 0 0 7.968-12.787z"
        />
      </g>
    </svg>
  ),
);
